import { useNamespaceCopy } from '@/i18n/ns';
import pageCatalog from '@/i18n/ns/connections-page';
import { ConnectionMark } from './your-connections/connection-mark';

/** A service Poneva connects itself (PostgreSQL, Shopify): the offer points to its setup. */
export type ChatConnectionSetup = {
  status: 'setup_required';
  settingsPath: string;
  service: { name: string; imageUrl?: string | null };
};

export function isChatConnectionSetup(value: unknown): value is ChatConnectionSetup {
  if (!value || typeof value !== 'object') return false;
  const offer = value as ChatConnectionSetup;
  return (
    offer.status === 'setup_required' &&
    typeof offer.settingsPath === 'string' &&
    offer.settingsPath.startsWith('/#/workspace/connections?') &&
    Boolean(offer.service) &&
    typeof offer.service.name === 'string' &&
    offer.service.name.length <= 120 &&
    (offer.service.imageUrl === undefined ||
      offer.service.imageUrl === null ||
      typeof offer.service.imageUrl === 'string')
  );
}

/** The setup a native service needs, opened in Connections like its catalogue tile. */
export function ChatConnectionSetupCard({ offer }: { offer: ChatConnectionSetup }) {
  const copy = useNamespaceCopy(pageCatalog);
  return (
    <section className="ws-chat-connections" aria-label={copy.chatTitle}>
      <div className="ws-chat-connections-heading">
        <strong>{copy.chatTitle}</strong>
      </div>
      <ChatConnectionSetupRow offer={offer} />
    </section>
  );
}

/** A native row is only a setup link; it never requests provider authorization. */
export function ChatConnectionSetupRow({ offer }: { offer: ChatConnectionSetup }) {
  const copy = useNamespaceCopy(pageCatalog);
  return (
    <div className="ws-chat-connect-row">
      <ConnectionMark name={offer.service.name} src={offer.service.imageUrl ?? null} state={null} />
      <div className="ws-chat-connect-copy">
        <strong>{offer.service.name}</strong>
      </div>
      <a
        className="ws-pipedream-connect"
        data-state="connect"
        data-emphasis="primary"
        href={offer.settingsPath}
      >
        {copy.tileConnect}
      </a>
    </div>
  );
}
